import { connect } from 'react-redux'
import GroupEntry from './group-entry'
import {
  getGroup,
  getGroupDeletingStatus,
  getGroupCreatingStatus,
  getGroupUpdatingStatus
} from '../../../../../stores/groups/groups.selectors'
import { setGroupSelectStatus } from '../../groups-component-redux/groups-component-redux.actions'
import { isGroupSelected } from '../../groups-component-redux/groups-component-redux.selectors'

const mapStateToProps = (state, { id }) => {
  const group = getGroup(state, id)
  const creating = getGroupCreatingStatus(state, id)
  const deleting = getGroupDeletingStatus(state, id)
  const updating = getGroupUpdatingStatus(state, id)
  return {
    mis: group.mis_group,
    pending: creating.pending || deleting.pending || updating.pending,
    title: group.title,
    access: group.visibility === 'public',
    students: group.number_of_students,
    worksPublished: group.number_of_published_works || '-',
    recieved: group.number_of_comments_received || '-',
    out: group.number_of_comments_left || '-',
    views: group.number_of_work_views || '-',
    selected: isGroupSelected(state, id)
  }
}

const mapDispatchToProps = dispatch => ({ dispatch })

const mergeProps = (stateProps, { dispatch }, ownProps) => ({
  ...ownProps,
  ...stateProps,
  onSelect: e => dispatch(setGroupSelectStatus(ownProps.id, e.target.checked))
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(GroupEntry)
